module.exports = function() {
  return new Worker(__webpack_public_path__ + "08e799a12335926729b6.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./~/pdfjs-dist/build/pdf.worker.js
// module id = 1288
// module chunks = 1